import parseDialogue from "../../util/parseDialogue";

export const SuperphreakC3 = parseDialogue(`
superphreak:c3:100-400

#100 Hey, newbie. Still working on getting S.M.A.R.T on its feet. What are you up to?
>200 Gonna hit this warez node.
>201 Do you know Wintermutant?

#200 Ah, Network City. Good idea. There are a couple more warez nodes hidden out on the net.
>300 Nice.

#201 He's a good kid. By the way, that node up there is Network City, and there are a couple more warez nodes hidden out on the net.
>300 Nice.

#300 And while you're looking at software, don't just load up on attack programs. You should check out some meta programs like Medic and Turbo. There may come a time when you need to boost up your hack to handle an ~~~~~ enemy. ~~~~~ ~~~ Oops gotta go.
>400 Close.
`);
